import { Outlet } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { ReactRouteAccessKey } from 'src/constants/reactRouter';
import { MyVerifyPage } from 'src/pages/my-verify';
import { RouteProps } from 'src/types/router';

const ROUTES: RouteProps[] = [
  {
    index: true,
    element: <MyVerifyPage />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
];

export const MY_VERIFY_ROUTE: RouteProps = {
  path: appRoutes.myVerify.index,
  element: <Outlet />,
  childRoutes: ROUTES,
  accessRoles: [ReactRouteAccessKey.isEmployee],
};
